import React from 'react';
import { TFunction } from 'i18next';
import PercentageBarCell from '@lib/components/Table/commonComponents/PercentageBarCell/PercentageBarCell';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import UserPreviewCell from '@lib/components/Table/commonComponents/UserPreviewCell/UserPreviewCell';
import { CellProps, Column } from '@lib/components/Table/types';
import formatCount from '@lib/utils/formatCount';
import { AiUsageByUserRow } from './types';

interface Args {
  language: string;
  t: TFunction;
}

// The column ids double as the keys of AiUsageByUserSortInputObject — renaming
// one silently breaks sorting.
export default function getAiUsageTableColumns({
  language,
  t,
}: Args): Column<AiUsageByUserRow>[] {
  return [
    {
      id: 'name',
      Header: t('name'),
      Cell: ({ item }: CellProps<AiUsageByUserRow>) => (
        <UserPreviewCell
          avatar={
            item.user.avatarAttached?.urls?.small ||
            item.user.avatarAttached?.urls?.original
          }
          name={`${item.user.firstName} ${item.user.lastName}`}
        />
      ),
      minWidth: 260,
      sortable: true,
    },
    {
      id: 'creditsUsed',
      Header: t('credits-used'),
      accessorFn: ({ item }) => formatCount(item.creditsUsed, language),
      Cell: (props: CellProps<AiUsageByUserRow>) => <TextCell {...props} />,
      minWidth: 160,
      sortable: true,
    },
    {
      id: 'sharePercentage',
      Header: t('share-of-usage'),
      // A slice of the total spend rather than consumption of a limit, so the
      // bar stays neutral. One decimal keeps small shares apart from a true 0%.
      Cell: ({ item }: CellProps<AiUsageByUserRow>) => (
        <PercentageBarCell
          neutral
          percentage={item.sharePercentage}
          precision={1}
        />
      ),
      minWidth: 220,
      sortable: true,
    },
  ];
}
